import CustomerAddressBook from "../../pages/smp/customer/addressbook";
import Bookings from "../../pages/smp/customer/bookings/containers/bookings";
import CustomerAgentTrack from "../../pages/smp/customer/customer-agent-tracking";
import CustomerHelpCenter from "../../pages/smp/customer/helpcenter";
import CustomerHome from "../../pages/smp/customer/home";
import CustomerOrder from "../../pages/smp/customer/sales/orders/containers/order";
import CustomerOrders from "../../pages/smp/customer/sales/orders/containers/orders";
import CustomerProfile from "../../pages/smp/customer/profile";
import OrderDetails from "../../pages/smp/customer/order-detail";
import { RoleGuard } from "../guards";
import CustomerQuotes from "../../pages/smp/customer/sales/quotes/containers/quotes";
import CustomerQuote from "../../pages/smp/customer/sales/quotes/containers/quote";
import CustomerLeads from "../../pages/smp/customer/sales/leads/containers/leads";
import CustomerLead from "../../pages/smp/customer/sales/leads/containers/lead";



export const smpCustomerAppRoutes = () => {
	return ([
		{ path: "home", element: <RoleGuard roles={["Internal"]}><CustomerHome /></RoleGuard> },
		{ path: "tracker", element: <RoleGuard roles={["Internal"]}><CustomerAgentTrack /></RoleGuard> },
		{ path: "sales/quotes", element: <RoleGuard roles={["Internal"]}><CustomerQuotes /></RoleGuard> },
		{ path: "sales/quotes/:id", element: <RoleGuard roles={["Internal"]}><CustomerQuote /></RoleGuard> },
		{ path: "sales/orders", element: <RoleGuard roles={["Internal"]}><CustomerOrders /></RoleGuard> },
		{ path: "sales/orders/:id", element: <RoleGuard roles={["Internal"]}><CustomerOrder /></RoleGuard> },
		{ path: "sales/leads", element: <RoleGuard roles={["Internal"]}><CustomerLeads /></RoleGuard> },
		{ path: "sales/leads/:id", element: <RoleGuard roles={["Internal"]}><CustomerLead /></RoleGuard> },
		{ path: "bookings", element: <RoleGuard roles={["Internal"]}><Bookings /></RoleGuard> },
		{ path: "order-details", element: <RoleGuard roles={["Internal"]}><OrderDetails /></RoleGuard> },
		{ path: "profile", element: <RoleGuard roles={["Internal"]}><CustomerProfile /></RoleGuard> },
		{ path: "helpcenter", element: <RoleGuard roles={["Internal"]}><CustomerHelpCenter /></RoleGuard> },
		{ path: "address", element: <RoleGuard roles={["Internal"]}><CustomerAddressBook /></RoleGuard> },
		
	])
};
